import Dropdown from 'antd/lib/dropdown'

import 'antd/lib/dropdown/style'

export * from 'antd/lib/dropdown'

export default Dropdown
